import { DISCOUNT_CARD_ACTIONS } from './actionTypes'

export const DiscountCardSelectors = {
	create: state => state.discountCard[DISCOUNT_CARD_ACTIONS.CREATE],
	view:   state => state.discountCard[DISCOUNT_CARD_ACTIONS.VIEW],
}
